import { inject, injectable } from "inversify";
import {
  ClientPortalCommentModel,
  CommentThreadRecipientModel,
  ICPLClientPortalCommentsClient,
} from "./api/cplapi/CPLAPI";
import { ClientPortalCommentUpdateModel } from "./classes/ClientPortalCommentUpdateModel";
import { ClientPortalNewCommentModel } from "./classes/ClientPortalNewCommentModel";
import { SERVICE_TYPES } from "setup/dependency/ServiceTypes";

export interface IClientPortalCommentsService {
  getComments(commentThreadID: string): Promise<ClientPortalCommentModel[]>;
  getCommentThreadRecipients(commentThreadID: string): Promise<CommentThreadRecipientModel[]>;
  createComment(newCommentModel: ClientPortalNewCommentModel): Promise<number>;
  updateComment(commentUpdateModel: ClientPortalCommentUpdateModel): Promise<void>;
  deleteComment(commentID: number): Promise<void>;
  downloadCommentAttachment(commentAttachmentID: number): Promise<File>;
}

@injectable()
export class ClientPortalCommentsService implements IClientPortalCommentsService {
  @inject(SERVICE_TYPES.CPLClientPortalCommentsClient) cplClientPortalCommentsClient!: ICPLClientPortalCommentsClient;

  async getComments(commentThreadID: string): Promise<ClientPortalCommentModel[]> {
    return this.cplClientPortalCommentsClient.getComments(commentThreadID);
  }

  async getCommentThreadRecipients(commentThreadID: string): Promise<CommentThreadRecipientModel[]> {
    return this.cplClientPortalCommentsClient.getCommentThreadRecipients(commentThreadID);
  }

  async createComment(newCommentModel: ClientPortalNewCommentModel): Promise<number> {
    return this.cplClientPortalCommentsClient.createComment(newCommentModel);
  }

  async updateComment(commentUpdateModel: ClientPortalCommentUpdateModel): Promise<void> {
    return this.cplClientPortalCommentsClient.updateComment(commentUpdateModel);
  }

  async deleteComment(commentID: number): Promise<void> {
    return this.cplClientPortalCommentsClient.deleteComment(commentID);
  }

  async downloadCommentAttachment(commentAttachmentID: number): Promise<File> {
    const fileResponse = await this.cplClientPortalCommentsClient.downloadCommentAttachment(commentAttachmentID);
    return new File([fileResponse.data], fileResponse.fileName!);
  }
}
